export function SurreyHero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/4062186c1ea4d09f98826d9e9649a82b.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center text-white py-24">
        <h1 className="font-['Fraunces'] text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Surrey Short Term Rental Regulations
        </h1>
        <p className="text-xl lg:text-2xl mb-8 leading-relaxed max-w-3xl mx-auto">
          Navigate Surrey's emerging rental market with expert guidance on licensing, compliance, and growth opportunities in BC's fastest-growing city
        </p>
        <button 
          onClick={scrollToContact}
          className="bg-[#882629] text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
        >
          Get Surrey Compliance Help
        </button>
      </div>
    </section>
  );
}
